let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e8nY9")).then(() => parcelRequire('l9I7G'));